import { createSelector } from '@ngrx/store';
import { IMessagesState } from './messages.reducer';

export const selectMessagesState = state => state.cmms.messagesState;

export const messagesFromLocation = createSelector(
	selectMessagesState,
	(state: IMessagesState) => state.allMessages
);

export const messagesIsLoading = createSelector(
	selectMessagesState,
	(state: IMessagesState) => state.messagesIsLoading
);

export const selectPaginationData = createSelector(
	selectMessagesState,
	(state: IMessagesState) => state.messagesPagination
);

export const selectPaginationOptions = createSelector(
	selectMessagesState,
	(state: IMessagesState) => state.paginationOptions
);

export const selectViewMessage = createSelector(
	selectMessagesState,
	(state: IMessagesState) => state.viewMessage
);

export const messageTextData = createSelector(
	selectMessagesState,
	(state: IMessagesState) => state.messageText
);
